<template>
	<div id="main">
		<div v-show="isSnpGeneVisible == false" style="background-color: white;">
			<div
					v-show="igvContainer1.igvjs_browser_visibility"
					id="igvContainer1"
					style="display: inline-block; width: 50%;"
			></div>
			<div
					v-show="igvContainer2.igvjs_browser_visibility"
					id="igvContainer2"
					style="display: inline-block; width: 50%;"
			></div>
		</div>
		<div v-show="isSnpGeneVisible == true" style="background-color: white;">
			<div
					v-show="igvContainer3.igvjs_browser_visibility"
					id="igvContainer3"
					style="width: 100%;"
			></div>
		</div>
	</div>
</template>

<script>
  import igv from "../../assets/igv-uec";
  import Cookies from "js-cookie";

  const genome_build = "hg19"; // 基因组浏览器加载的基因组版本
  // const name = "DEMO"; // 显示的track名称
  // const bam_file_path =
  //   "/mnt/xtvol/iwand/uec0401/jobs/5d44491188254bfe938152605b03f749/iwandresultfiles/Demo1.Aligned.sortedByCoord.out.markDup.bam"; // 加载文件路径
  // const roi_file_path =
  //   "/mnt/xtvol/iwand/uec0401/jobs/5d44491188254bfe938152605b03f749/iwandresultfiles/roi.bed"; // ROI文件路径
  const interval = 400; // 显示的基因组区间范围

  const build_options = function (record, bam_file_path, roi_file_path, name) {
    const serverGenomeList = process.env.VUE_APP_IGV_GENOMELIST_URL;
    const options = {
      genomeList: serverGenomeList,
      genome: genome_build,
      locus: `chr${record.chromosome}:${record.position -
      interval}-${record.position + interval}`,
      tracks: [
        {
          name: name,
          url: `/api/jobsvisualization/files?filePath=${bam_file_path}`,
          indexURL: `/api/jobsvisualization/files?filePath=${bam_file_path}.bai`,
          format: "bam",
          oauthToken: Cookies.get("token"),
          roi: [
            {
              name: "fusion point",
              url: `/api/jobsvisualization/files?filePath=${roi_file_path}`,
              indexURL: `/api/jobsvisualization/files?filePath=${roi_file_path}.tbi`,
              color: "rgba(0, 150, 50, 0.25)",
              oauthToken: Cookies.get("token")
            }
          ]
        }
      ]
    };
    return options;
  };
  const build_options2 = function (record, item) {
    const serverGenomeList = process.env.VUE_APP_IGV_GENOMELIST_URL;
    const bamPath = item.bamPath;
    const indelVepVcfGzPath = item.indelVepVcfGzPath;
    const snpVepVcfGzPath = item.snpVepVcfGzPath;
    const options = {
      genomeList: serverGenomeList,
      genome: genome_build,
      locus: `chr${record.chromosome}:${record.position -
      interval}-${record.position + interval}`,
      tracks: [
        {
          name: 'SNP',
          url: `/api/jobsvisualization/files?filePath=${snpVepVcfGzPath}`,
          indexURL: `/api/jobsvisualization/files?filePath=${snpVepVcfGzPath}.tbi`,
          format: "vcf",
          type: "variant",
          oauthToken: Cookies.get('token'),
        },
        {
          name: 'INDEL',
          url: `/api/jobsvisualization/files?filePath=${bamPath}`,
          indexURL: `/api/jobsvisualization/files?filePath=${bamPath}.bai`,
          format: "bam",
          oauthToken: Cookies.get("token"),
          roi: [
            {
              name: "fusion point",
              url: `/api/jobsvisualization/files?filePath=${indelVepVcfGzPath}`,
              indexURL: `/api/jobsvisualization/files?filePath=${indelVepVcfGzPath}.tbi`,
              color: "rgba(0, 150, 50, 0.25)",
              oauthToken: Cookies.get("token")
            }
          ]
        },
        {
          name: 'Alignment',
          url: `/api/jobsvisualization/files?filePath=${bamPath}`,
          indexURL: `/api/jobsvisualization/files?filePath=${bamPath}.bai`,
          format: "bam",
          type: "alignment",
          oauthToken: Cookies.get('token'),
        }
      ]
    };
    // let options =
    //       {
    //           genome: "hg38",
    //           locus: "chr8:127,736,588-127,739,371",
    //           tracks: [
    //               {
    //                   "name": "HG00103",
    //                   "url": "https://s3.amazonaws.com/1000genomes/data/HG00103/alignment/HG00103.alt_bwamem_GRCh38DH.20150718.GBR.low_coverage.cram",
    //                   "indexURL": "https://s3.amazonaws.com/1000genomes/data/HG00103/alignment/HG00103.alt_bwamem_GRCh38DH.20150718.GBR.low_coverage.cram.crai",
    //                   "format": "cram"
    //               }
    //           ]
    //       };
    return options;
  };

  export default {
    data: function () {
      return {
        igvContainer1: {
          browser: null,
          igvjs_browser_visibility: false
        },
        igvContainer2: {
          browser: null,
          igvjs_browser_visibility: false
        },
        igvContainer3: {
          browser: null,
          igvjs_browser_visibility: false
        },
        isSnpGeneVisible: false,
      };
    },
    props: {
      record: {
        type: Object,
        default: () => {
        }
      }
    },
    watch: {
      record(val) {
        if (this.record && (this.record.fileType == 'fusion' || this.record.fileType == 'cicero')) {
          if (val.data1.label == 'not-converted-' && val.data2.label != 'not-converted-') {
            this.igvContainer1.igvjs_browser_visibility = true;
            this.show_igvjs_browser(val.data2, "igvContainer2");
          } else if (val.data1.label != 'not-converted-' && val.data2.label == 'not-converted-') {
            this.igvContainer2.igvjs_browser_visibility = true;
            this.show_igvjs_browser(val.data1, "igvContainer1");
          } else {
            this.show_igvjs_browser(val.data1, "igvContainer1");
            this.show_igvjs_browser(val.data2, "igvContainer2");
          }
        } else {
          this.show_igvjs_browser(val.data1, "igvContainer3");
        }
      }
    },
    mounted() {
      // .fusion.level.txt.sort 判断融合基因组文件
      // .snp.level.txt.sort 判断突变基因组文件
      if (this.record && (this.record.fileType == 'fusion' || this.record.fileType == 'cicero')) {
        this.isSnpGeneVisible = false;
        if (this.record.data1.label == 'not-converted-' && this.record.data2.label != 'not-converted-') {
          this.show_igvjs_browser(this.record.data2, "igvContainer2", this.record);
        } else if (this.record.data1.label != 'not-converted-' && this.record.data2.label == 'not-converted-') {
          this.show_igvjs_browser(this.record.data1, "igvContainer1", this.record);
        } else {
          this.show_igvjs_browser(this.record.data1, "igvContainer1", this.record);
          this.show_igvjs_browser(this.record.data2, "igvContainer2", this.record);
        }
      } else {
        this.isSnpGeneVisible = true;
        this.show_igvjs_browser(this.record.data1, "igvContainer3", this.record);
      }

    },
    methods: {
      show_igvjs_browser: function (record, browser, item) {
        // 仅首次加载基因组浏览器时初始化相关配置
        // 后续点击过程中使用igv.browser.search('<string:chromosome>:<int:start>-<int:end>')来定位到指定基因组区域，
        // 避免重复加载（部分）数据，来提高加载和显示速度
        // 如果this.browser存有浏览器信息，则表示已经初始化
        console.log(record, browser, item)
        if (this[browser].browser) {
          this[browser].browser.search(
            `chr${record.chromosome}:${record.position -
            interval}-${record.position + interval}`
          );
        } else {
          this[browser].igvjs_browser_visibility = true;
          const igvDiv = document.getElementById(browser);
          let buildOpt = build_options(record, item.bamPath, item.bedGzPath, item.name);
          if (browser == 'igvContainer3') {
            if (item.fileType == 'indel') {
              buildOpt = build_options(record, item.bamPath, item.indelVepVcfGzPath, item.name);
            } else {
              buildOpt = build_options2(record, item);
            }
          }
          igv
            .createBrowser(
              igvDiv,
              buildOpt
            )
            .then(
              function (browserObj) {
                browserObj.$root.find('.igv-nav-bar-toggle-button-container .igv-nav-bar-button:eq(1)').click();
                this[browser].browser = browserObj; // 初始化igv.browser
              }.bind(this)
            );
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
	#main {
		min-height: 650px;
	}
</style>